import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';

import {
  Box,
  Button,
  InputAdornment,
  IconButton,
  Modal,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

const ModalToAddItem = ({ open, handleClose, newItems, allLayerList, allMapList, layerList }) => {
  const [importFile, setImportFile] = React.useState('');
  const [dataFile, setDataFile] = React.useState('');

  const [newName, setNewName] = React.useState('');
  const [layersOfMapState, setLayersOfMapState] = React.useState([]);
  const [baseLayersOfMapState, setBaseLayersOfMapState] = React.useState([]);
  const list = newItems[0].itemName === 'layers' ? layerList : allLayerList;
  const [layerListArray, setLayerListArray] = React.useState(list);
  const fileInputRef = React.useRef(null);
  const fileInputRefLayer = React.useRef(null);
  const fileInputRefBaseLayer = React.useRef(null);

  const userId = Meteor.userId();

  const handleRestore = layerId => {
    const restore = async () => {
      try {
        await methodPromise('layers.restore', layerId);
        Bert.alert('Layer Restored!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    };
    restore();
  };

  const createNewItem = async () => {
    if (!isEmpty(newName)) {
      dataFile.name = newName;
      if (newItems[0].itemName === 'layers') {
        const propiedadesAEliminar = [
          '_id',
          'owner',
          'createdAt',
          'updatedAt',
          'sharedData',
          'sharedPrivateData',
          'publicDataId',
          'deleted'
        ];
        propiedadesAEliminar.forEach(propiedad => {
          if (propiedad in dataFile) {
            delete dataFile[propiedad];
          }
        });
        try {
          await methodPromise('layers.insert', dataFile);
          setLayersOfMapState([]);
          setImportFile('');
          setNewName('');
          Bert.alert('Layer created!', 'success');
        } catch (error) {
          handleErrorInClient(error);
        }
      } else if (newItems[0].itemName === 'maps') {
        if (
          layersOfMapState.every(item => item.exist) &&
          baseLayersOfMapState.every(item => item.exist)
        ) {
          const propiedadesAEliminar = [
            '_id',
            'owner',
            'createdAt',
            'publicId',
            'publicPrivateId',
            'updatedAt',
            'shared',
            'sharedPrivate',
            'withLocation',
            'withLocationPrivate',
            'deleted'
          ];
          propiedadesAEliminar.forEach(propiedad => {
            if (propiedad in dataFile) {
              delete dataFile[propiedad];
            }
          });
          if ('_id' in dataFile) {
            const existeID = allMapList.some(item => item._id === dataFile._id);
            if (existeID === true) {
              delete dataFile._id;
            }
          }
          try {
            await methodPromise('maps.insert', dataFile);
            setLayersOfMapState([]);
            setImportFile('');
            setNewName('');
            Bert.alert('Map created!', 'success');
          } catch (error) {
            handleErrorInClient(error);
          }
        } else {
          Bert.alert('No existen todas las layers!', 'warning');
        }
      }
    } else {
      Bert.alert('The name of the layer is empty.', 'warning');
    }
  };

  const saveLayer = async (file, id) => {
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = async () => {
      const { result } = fileReader;
      const parsedText = JSON.parse(result);
      const fileText = parsedText[0];
      const fileImport = isEmpty(fileText) ? parsedText : fileText;
      const propiedadesAEliminar = [
        'owner',
        'createdAt',
        'updatedAt',
        'sharedData',
        'sharedPrivateData',
        'publicDataId',
        'deleted'
      ];
      propiedadesAEliminar.forEach(propiedad => {
        if (propiedad in fileImport) {
          delete fileImport[propiedad];
        }
      });

      let idLayer = '';
      layersOfMapState.forEach(layer => {
        if (layer.id === id) {
          if (layer.exist === true) {
            idLayer = Array.from(18, () => Math.random().toString(36)[2]).join('');
          } else {
            idLayer = id;
          }
        }
      });
      fileImport._id = idLayer;

      try {
        await methodPromise('layers.insert', fileImport);
        const layersOfMapActualizado = layersOfMapState.map(layer => {
          if (layer.id === id) {
            return {
              ...layer,
              name: fileImport.name,
              exist: true,
              owner: true
            };
          }
          return layer;
        });

        const layersOfIds = layersOfMapActualizado.map(obj => obj.id);
        setDataFile({ ...dataFile, layers: layersOfIds });
        const layersUpdated = [...layerListArray, fileImport];
        setLayerListArray(layersUpdated);
        setLayersOfMapState(layersOfMapActualizado);
        fileInputRefLayer.current = document.getElementById('fileInputLayer');
        Bert.alert('Layer created!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    };
  };

  const saveBaseLayer = async (file, id) => {
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = async () => {
      const { result } = fileReader;
      const parsedText = JSON.parse(result);
      const fileText = parsedText[0];
      const fileImport = isEmpty(fileText) ? parsedText : fileText;
      const propiedadesAEliminar = [
        'owner',
        'createdAt',
        'updatedAt',
        'sharedData',
        'sharedPrivateData',
        'publicDataId',
        'deleted'
      ];
      propiedadesAEliminar.forEach(propiedad => {
        if (propiedad in fileImport) {
          delete fileImport[propiedad];
        }
      });

      let idLayer = '';

      baseLayersOfMapState.forEach(layer => {
        if (layer.id === id) {
          if (layer.exist === true) {
            idLayer = Array.from(18, () => Math.random().toString(36)[2]).join('');
          } else {
            idLayer = id;
          }
        }
      });
      fileImport._id = idLayer;

      try {
        await methodPromise('layers.insert', fileImport);
        const baseLayerOfMapActualizado = baseLayersOfMapState.map(layer => {
          if (layer.id === id) {
            return {
              ...layer,
              name: fileImport.name,
              exist: true,
              owner: true
            };
          }
          return layer;
        });
        const baseMapsOfIds = baseLayerOfMapActualizado.map(obj => obj.id);

        setDataFile({ ...dataFile, baseMaps: baseMapsOfIds });
        const layersUpdated = [...layerListArray, fileImport];
        setLayerListArray(layersUpdated);
        setBaseLayersOfMapState(baseLayerOfMapActualizado);
        fileInputRefBaseLayer.current = document.getElementById('fileInputBaseLayer');
        Bert.alert('Layer created!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    };
  };

  const loadFile = file => {
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = async () => {
      const { result } = fileReader;
      const parsedText = JSON.parse(result);
      const fileText = parsedText[0];
      const fileImport = isEmpty(fileText) ? parsedText : fileText;
      if (newItems[0].itemName === 'maps') {
        setDataFile(fileImport);
        const idConEstado = fileImport.layers.map(id => {
          const capa = layerListArray.find(item => item._id === id);
          const userState = !!(capa && capa.owner === userId);
          const deletedState = !!(capa && !capa.deleted === 'no');
          return {
            id,
            exist: !!capa,
            name: capa ? capa.name : null,
            owner: !!userState,
            deleted: !!deletedState
          };
        });
        const idConEstadoBaseMaps = fileImport.baseMaps.map(id => {
          const capa = layerListArray.find(item => item._id === id);
          const userState = !!(capa && capa.owner === userId);
          const deletedState = !!(capa && !capa.deleted === 'no');
          return {
            id,
            exist: !!capa,
            name: capa ? capa.name : null,
            owner: !!userState,
            deleted: !!deletedState
          };
        });
        setBaseLayersOfMapState(idConEstadoBaseMaps);
        setLayersOfMapState(idConEstado);
      } else if (newItems[0].itemName === 'layers') {
        setDataFile(fileImport);
      }
    };

    fileReader.onerror = () => {
      Bert.alert('Error on load file', 'danger');
    };
  };

  const body = (
    <Box backgroundColor="white" height="70vh" width="70vw">
      <Box
        height="10%"
        width="100%"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 16px'
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          New {newItems[0].itemName}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            color="success"
            variant="outlined"
            onClick={() => {
              handleClose();
            }}
            sx={{ marginLeft: '16px' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Box
        width="80%"
        spacing={1}
        sx={{
          display: 'column',
          alignItems: 'center'
        }}
      >
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%',
            alignItems: 'center'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            label="Nombre del archivo"
            size="small"
            value={importFile ? importFile.name : ''}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    variant="contained"
                    aria-label="upload"
                    component="label"
                    style={{
                      color: '#2A3F90'
                    }}
                    onClick={() => {
                      fileInputRef.current.click();
                    }}
                  >
                    <PlagiarismOutlinedIcon />
                  </IconButton>
                  <input
                    ref={fileInputRef}
                    type="file"
                    style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                    onChange={event => {
                      setLayersOfMapState([]);
                      setBaseLayersOfMapState([]);
                      setImportFile(event.target.files[0]);
                      loadFile(event.target.files[0]);
                    }}
                  />
                </InputAdornment>
              )
            }}
          />
          <Box
            component="form"
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center'
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="outlined-required"
              label={newItems[0].itemName === 'layers' ? 'Name of layer' : 'Name of map'}
              size="small"
              value={newName}
              onChange={event => setNewName(event.target.value)}
              mb={2}
              fullWidth
            />
          </Box>
        </Box>
        {!isEmpty(layersOfMapState) && (
          <>
            <Box
              component="form"
              sx={{
                display: 'flex',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <Typography variant="h6" fontWeight="bold">
                Layers list:
              </Typography>
            </Box>
            <Box
              component="form"
              sx={{
                display: 'flex',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <TableContainer sx={{ maxHeight: 155 }}>
                <Table>
                  <TableBody>
                    {layersOfMapState.map(({ id, exist, name, deleted, owner }) => (
                      <TableRow key={id}>
                        {exist === true && owner === true ? (
                          <TableCell>{name}</TableCell>
                        ) : (
                          <>
                            <TableCell>{id}</TableCell>
                            <TableCell>
                              <IconButton
                                size="small"
                                aria-label="upload layer"
                                onClick={() => {
                                  fileInputRefLayer.current.click();
                                }}
                                style={{
                                  color: '#2A3F90'
                                }}
                              >
                                <FileUploadIcon />
                              </IconButton>
                              <input
                                id="fileInputLayer"
                                ref={fileInputRefLayer}
                                type="file"
                                style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                                onChange={event => {
                                  saveLayer(event.target.files[0], id);
                                }}
                              />
                              <IconButton
                                size="small"
                                aria-label="delete layer"
                                onClick={() => {
                                  const index = layersOfMapState.findIndex(item => item.id === id);
                                  if (index !== -1) {
                                    const newArray = layersOfMapState.filter((_, i) => i !== index);
                                    setLayersOfMapState(newArray);
                                  }
                                }}
                                style={{
                                  color: '#2A3F90'
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                              {deleted === true && (
                                <IconButton
                                  size="small"
                                  aria-label="Recover layer"
                                  onClick={() => {
                                    handleRestore(id);
                                  }}
                                  style={{
                                    color: '#2A3F90'
                                  }}
                                >
                                  <UTurnLeftIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </>
        )}
        {!isEmpty(baseLayersOfMapState) && (
          <>
            <Box
              component="form"
              sx={{
                display: 'flex',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <Typography variant="h6" fontWeight="bold">
                Base layers list:
              </Typography>
            </Box>
            <Box
              component="form"
              sx={{
                display: 'flex',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <TableContainer sx={{ maxHeight: 155 }}>
                <Table>
                  <TableBody>
                    {baseLayersOfMapState.map(({ id, exist, name, deleted, owner }) => (
                      <TableRow key={id}>
                        {exist === true && owner === true ? (
                          <TableCell>{name}</TableCell>
                        ) : (
                          <>
                            <TableCell>{id}</TableCell>
                            <TableCell>
                              <IconButton
                                size="small"
                                aria-label="upload layer"
                                onClick={() => {
                                  fileInputRefLayer.current.click();
                                }}
                                style={{
                                  color: '#2A3F90'
                                }}
                              >
                                <FileUploadIcon />
                              </IconButton>
                              <input
                                id="fileInputBaseLayer"
                                ref={fileInputRefBaseLayer}
                                type="file"
                                style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                                onChange={event => {
                                  saveBaseLayer(event.target.files[0], id);
                                }}
                              />
                              <IconButton
                                size="small"
                                aria-label="delete layer"
                                onClick={() => {
                                  const index = baseLayersOfMapState.findIndex(
                                    item => item.id === id
                                  );
                                  if (index !== -1) {
                                    const newArray = baseLayersOfMapState.filter(
                                      (_, i) => i !== index
                                    );
                                    setBaseLayersOfMapState(newArray);
                                  }
                                }}
                                style={{
                                  color: '#2A3F90'
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                              {deleted === true && (
                                <IconButton
                                  size="small"
                                  aria-label="Recover layer"
                                  onClick={() => {
                                    handleRestore(id);
                                  }}
                                  style={{
                                    color: '#2A3F90'
                                  }}
                                >
                                  <UTurnLeftIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </>
        )}

        <Button
          onClick={() => {
            createNewItem();
          }}
          variant="contained"
          color="success"
        >
          Save
        </Button>
      </Box>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      style={{
        position: 'absolute',
        bgcolor: 'white',
        top: '15vh',
        left: '15vw'
      }}
    >
      {body}
    </Modal>
  );
};

ModalToAddItem.defaultProps = { allLayerList: [], allMapList: [], layerList: [] };

ModalToAddItem.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  newItems: PropTypes.array.isRequired,
  allMapList: PropTypes.array,
  allLayerList: PropTypes.array,
  layerList: PropTypes.array
};

export default ModalToAddItem;
